import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "utilityVanMediumFilled"
const UtilityVanMediumFilledIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path d="M6.375 15C7.411 15 8.25 15.84 8.25 16.875S7.41 18.75 6.375 18.75 4.5 17.91 4.5 16.875 5.34 15 6.375 15M17.625 15C18.66 15 19.5 15.84 19.5 16.875S18.66 18.75 17.625 18.75 15.75 17.91 15.75 16.875 16.59 15 17.625 15" />
          <path
            fillRule="evenodd"
            d="M16.919 6.188C17.807 6.188 18.594 6.756 18.875 7.598L19.96 10.851 21.587 11.665C22.03 11.887 22.313 12.342 22.313 12.839V13.5H21.75C21.44 13.5 21.188 13.752 21.188 14.063S21.439 14.625 21.75 14.625H22.313V16.125C22.313 16.85 21.725 17.438 21 17.438H20.189Q20.249 17.165 20.25 16.875C20.25 15.425 19.075 14.25 17.625 14.25S15 15.425 15 16.875Q15.001 17.165 15.062 17.438H8.938Q9 17.165 9 16.875C9 15.425 7.825 14.25 6.375 14.25S3.75 15.425 3.75 16.875Q3.751 17.165 3.812 17.438H3C2.275 17.438 1.688 16.85 1.688 16.125V14.625H2.25C2.56 14.625 2.813 14.373 2.813 14.063S2.56 13.5 2.25 13.5H1.688V12.75H2.25C2.56 12.75 2.813 12.498 2.813 12.188S2.56 11.625 2.25 11.625H1.688V7.5C1.688 6.775 2.274 6.188 3 6.188zM15.187 10.5C15.188 10.604 15.272 10.688 15.376 10.688H18.719L17.81 7.953C17.68 7.571 17.321 7.313 16.918 7.313H15.187z"
            clipRule="evenodd"
          />
        </svg>
      }
    </span>
  )
}
export default UtilityVanMediumFilledIcon
